import productionConfigs from './production'

const beta1Configs = {
  ...productionConfigs,
} as const

export default beta1Configs
